<page-load-header *ngIf="!initialized"></page-load-header>

<div *ngIf="!finished">
  <div *ngIf="initialized">

    <!-- Header with Logo -->
  

    <!-- Centered Content Wrapper -->
    <div class="page-wrapper">
      <div class="header pb-3">
        <div class="container-fluid header-container">
          <div class="header-body">
            <div class="row align-items-center py-4">
              <div class="col-lg-12 text-center">
                <h6 class="h2 d-inline-block mb-0"></h6>
              </div>
            </div>
          </div>
          <a href="https://rundna.com/" target="_blank" rel="noopener noreferrer">
            <div class="logo-container">
              <img src="../../../../assets/img/runningreport/logo.png" alt="Logo" class="site-logo">
            </div>
          </a>
        </div>
      </div>

      <form class="form" [formGroup]="formGroup" novalidate>

        <div class="card">
          <div class="card-header">
            <h5 class="mb-0">2D AI Assessment</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <!-- Left Section: Guidelines -->
              <div class="col-6 row-flex-media">
                <div class="main-container">
                  <div class="guideline-title">2D Video Guidelines</div>
                  <div class="guideline-container">
                    <!-- Required -->
                    <div class="guideline-box">
                      <div class="text-center">
                        <embed-video-player [encoded]="true" [privateVideo]="true" [azureUrl]="'https://wv-cdn-00-00.wowza.com/ea8c6bfa-c593-4e7f-9cb5-63eeeb7b20ec/cmaf/15c7fd9a-4d31-4f6a-b3e9-cc10e46a9baa/playlist.m3u8'" [size]="'large'"></embed-video-player>
                      </div>

                    </div>

                    <!-- Recommended -->
                    <div class="guideline-box">
                      <div class="text-center">
                        <embed-video-player [encoded]="true" [privateVideo]="true" [azureUrl]="'https://wv-cdn-00-00.wowza.com/ea8c6bfa-c593-4e7f-9cb5-63eeeb7b20ec/cmaf/13f7fdf5-3cb3-4cd7-8b76-e55c12420c2d/playlist.m3u8'" [size]="'large'"></embed-video-player>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Right Section: Form Inputs -->
              <div class="col-6 row-flex-media">
                <div class="main-container">
                  <div class="guideline-title">Assessment Data</div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label class="form-control-label" for="publicUserEmail"><span style="color:red;">*</span> Email</label>
                        <input class="form-control"
                               formControlName="publicUserEmail"
                               maxlength="75"
                               type="email"
                               placeholder="Enter your email" />

                        <!-- Email required -->
                        <div class="invalid-message" *ngIf="formGroup?.controls['publicUserEmail'].errors?.required">
                          <div>Email is required</div>
                        </div>

                        <!-- Invalid email format -->
                        <div class="invalid-message" *ngIf="formGroup?.controls['publicUserEmail'].errors?.email">
                          <div>Please enter a valid email address</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Runner Weight -->
                  <div class="row align-items-end form-group">
                    <div class="col-md-8">
                      <label class="form-control-label" for="runnerWeight"><span style="color:red;">*</span> Runner Weight</label>
                      <input class="form-control"
                             formControlName="runnerWeight"
                             placeholder="Weight (e.g., 154)"
                             type="text"
                             (input)="onDecimalInput($event)"
                             inputmode="decimal" />
                    </div>
                    <div class="col-md-4">
                      <select class="form-control" formControlName="weightUnit" id="weightUnit">
                        <option [ngValue]="1">Lb</option>
                        <option [ngValue]="2">Kg</option>
                      </select>
                    </div>
                    <div class="col-md-12">
                      <div class="invalid-message-visible p-1" *ngIf="formGroup.controls['runnerWeight'].dirty && formGroup?.controls['runnerWeight'].errors?.required">
                        <div>Weight is required</div>
                      </div>

                      <div class="invalid-message-visible p-1" *ngIf="formGroup.controls['runnerWeight'].dirty && formGroup?.controls['runnerWeight'].errors?.min">
                        <div>Weight is too low</div>
                      </div>
                    </div>
                  </div>

                  <!-- Runner Height -->
                  <div class="row align-items-end form-group">
                    <div class="col-md-8">
                      <label class="form-control-label" for="runnerHeight"><span style="color:red;">*</span> Runner Height</label>
                      <input class="form-control"
                             formControlName="runnerHeight"
                             placeholder="Height (e.g., 70.5)"
                             type="text"
                             (input)="onDecimalInput($event)"
                             inputmode="decimal" />
                    </div>
                    <div class="col-md-4">
                      <select class="form-control" formControlName="heightUnit" id="heightUnit">
                        <option [ngValue]="2">Inches</option>
                        <option [ngValue]="1">Cm</option>
                      </select>
                    </div>
                    <div class="col-md-12">
                      <div class="invalid-message-visible p-1" *ngIf="formGroup.controls['runnerHeight'].dirty && formGroup?.controls['runnerHeight'].errors?.required">
                        <div>Height is required</div>
                      </div>

                      <div class="invalid-message-visible p-1" *ngIf="formGroup.controls['runnerHeight'].dirty && formGroup?.controls['runnerHeight'].errors?.min">
                        <div>Value is too low</div>
                      </div>
                    </div>
                  </div>
                  <!-- Video Upload Section -->
                  <div class="row align-items-end">
                    <div class="col-12">
                      <div formArrayName="videos" class="formGroupContainer" *ngFor="let video of formGroup.get('videos').controls; let v = index">
                        <div class="row formGroupName sortable-show-hover" [formGroupName]="v">
                          <div class="col-md-12">

                            <video-upload *ngIf="!video.get('id').value"
                                          [label]="v === 0 ? '* Video ' + (v + 1) + ' - Side View Left or Right 3-5 seconds, UP to 100Mb' : '* Video ' + (v + 1) + ' - Back View 3-5 seconds, UP to 100Mb'"
                                          [allowAnonymous]="true"
                                          [validateCameraUse]="true"
                                          formControlName="videoId">
                            </video-upload>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div *ngIf="formGroup.get('videos')?.errors?.twoVideosRequired && (formGroup.get('videos')?.touched || formGroup.get('videos')?.dirty)">
                      <div class="text-danger">Please upload both videos</div>
                    </div>
                  </div>

                  <div class="row align-items-end" style="margin-top: 1em;">
                    <div class="col-12">
                      <div>
                        <input class="d-inline single-checkbox align-bottom mr-1" type="checkbox" formControlName="isInjured" />
                        <label class="d-inline"> Do you currently have an injury or pain while you run? </label>
                      </div>
                      <div>
                        <input class="d-inline single-checkbox align-bottom mr-1" type="checkbox" formControlName="allowUse" />
                        <label class="d-inline"><span style="color:red;">*</span> I agree to the <a href="javascript:void(0)" (click)="onViewTerms()">Terms of Service and Privacy policy </a> </label>
                        <div *ngIf="formGroup.controls['allowUse'].dirty && formGroup.controls['allowUse'].errors" class="invalid-message-visible p-1">
                          <div>Please confirm to continue</div>
                        </div>
                      </div>
                      <div>
                        <input id="acceptTerm" class="d-inline single-checkbox align-bottom mr-1" type="checkbox" formControlName="acceptTerm" />
                        <label for="acceptTerm" class=" d-inline"><span style="color:red;">*</span> I understand my videos may be used to improve RunDNA's Running Form Analysis Tools </label>
                        <div *ngIf="formGroup.controls['acceptTerm'].dirty && formGroup.controls['acceptTerm'].errors" class="invalid-message-visible p-1">
                          <div>Please confirm to continue</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <!-- Submit Button -->
        <div class="row">
          <div class="col text-right">
            <button (click)="onSave(false)" [promiseBtn]="submitComplete" class="btn btn-primary">Analyze</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Finished State -->
<div *ngIf="finished" class="container mt-5">
  <div class="row justify-content-center">
    <div class="col-md-8">
      <div class="card shadow-lg p-4 text-center">
        <div class="card-body">
          <div class="mb-4">
            <i class="fas fa-check-circle text-success" style="font-size: 3rem;"></i>
          </div>
          <h3 class="mb-3">Assessment Submitted Successfully!</h3>
          <p class="lead">
            Your report has been created and is now being processed.
          </p>
          <p>
            Results will be available in a few minutes.<br>
            You will receive an <strong>email notification</strong> when the analysis is complete.
          </p>
          <div class="mt-4">
            <button class="btn btn-secondary ml-2" (click)="reloadPage()">
              Create Another Assessment
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
